var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0778 17.7063L12.6263 13.1763C13.792 11.8665 14.5083 10.1343 14.5083 8.22822C14.5077 4.15071 11.2602 0.845703 7.25385 0.845703C3.24752 0.845703 0 4.15071 0 8.22822C0 12.3057 3.24752 15.6107 7.25385 15.6107C8.98486 15.6107 10.5725 14.9915 11.8196 13.9621L16.2883 18.51C16.506 18.7318 16.8595 18.7318 17.0773 18.51C17.2955 18.2882 17.2955 17.9282 17.0778 17.7063ZM7.25385 14.4749C3.86406 14.4749 1.11611 11.6782 1.11611 8.22822C1.11611 4.77827 3.86406 1.98155 7.25385 1.98155C10.6437 1.98155 13.3916 4.77827 13.3916 8.22822C13.3916 11.6782 10.6437 14.4749 7.25385 14.4749Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.6e59d43986c8cac729237f4f136ced7a.svg";
export { ForwardRef as ReactComponent };